module.exports = __webpack_public_path__ + "assets/MultiCoreData.566b912d.svg";